<template>
  <div :class="{'config-item': true, 'bg-success': selected}">
      <span class="handle ui-sortable-handle">
            <i class="fa fa-arrows"></i>
        </span>
    <span class="text">{{el.name}}</span>
    <div class="tools">
      <div class="btn-group btn-group-sm">
        <button class="btn btn-default" data-toggle="tab" data-target="#editMenuItem" @click="select(el)" title="View or edit this item"><i class="fa fa-pencil"></i></button>
        <button class="btn btn-default" data-toggle="tab" data-target="#createMenu" @click="select(el)" title="Create Submenu for this item"><i class="fa fa-plus"></i></button>
        <button class="btn btn-default" data-toggle="modal" data-target="#deleteMenuModal" @click="select(el)" title="Delete this item"><i class="fa fa-trash text-danger"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NavMenu",
    props: ['el', 'bus'],
    data () {
      return {
        selected: false
      }
    },
    created () {
      this.bus.$on('select', (who) => {
        this.selected = who.id === this.el.id
      })
    },
    methods: {
      select (el) {
        this.selected = true
        this.bus.$emit('select', el)
      },
    }
  }
</script>

<style scoped>

</style>
